<app-breadcrumb *ngIf="qualityService.refereshBreadCrumb"></app-breadcrumb>

<div class="page-loading-shade" style="margin-top: 18px;" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="mt-4" *ngIf="qualityService.showmodulegrid">
  <div class="ms-5 d-flex gap-2 align-items-center change_request_chip">
    <div *ngIf="qualityService.moduleName=='CR'">
      <svg width="24" height="25" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.8998 22.347H5.69979C4.37431 22.347 3.2998 21.2725 3.2998 19.947L3.2999 5.54708C3.29991 4.2216 4.37442 3.14709 5.6999 3.14709H16.5002C17.8256 3.14709 18.9002 4.22161 18.9002 5.54709V6.74707M14.1428 21.1471L11.7002 18.6928M11.7002 18.6928L14.0323 16.3471M11.7002 18.6928H18.9273C19.9064 18.6928 20.7002 17.8991 20.7002 16.92M17.5574 9.74707L20 12.2013M20 12.2013L17.6678 14.5471M20 12.2013H12.7729C11.7937 12.2013 11 12.9951 11 13.9742"
          stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div *ngIf="qualityService.moduleName=='CAPA'">
      <img width="24" height="25" class="svg_dimension" src="../../assets/img/CAPA.svg" alt="" />
    </div>
    <div *ngIf="qualityService.moduleName=='DV'">
      <img width="24" height="25" class="svg_dimension" src="../../assets/img/Deviations.svg" alt="" />
    </div>
    <div *ngIf="qualityService.moduleName=='AU'">
      <img width="24" height="25" lass="svg_dimension" src="../../assets/img/Audit_cr.svg" alt="" alt="" />
    </div>
    <div *ngIf="qualityService.moduleName=='QI'">
      <img width="24" height="25" class="svg_dimension" src="../../assets/img/Quality Issues.svg" alt="" />
    </div>
    <div *ngIf="qualityService.moduleName=='CC'">
      <img width="24" height="25" class="svg_dimension" src="../../assets/img/Customer Complaints.svg" alt="" />
    </div>
    <div *ngIf="qualityService.moduleName=='IN'">
      <img width="24" height="25" class="svg_dimension" src="../../assets/img/investigation.png" alt="" />
    </div>
    <span class="hash active_page">{{ qualityService.moduleFullName }} ({{ qualityService.activity.chartStatus
      }})</span>
    <span *ngIf="chartFilter.filterCondition">
      <img src="../../../assets/img/qms_img/filter.svg" width="18px" height="18px" alt="filter">
    </span>
  </div>

  <div class="position-relative cr_content">
    <div class="d-none row" style="margin-top: 18px">
      <div class="col-sm-6 group-dropdown-container">
        <label id="searchModule-required-msg" for="email">Group</label>
        <span class="mandatory-symbol">*</span>
        <div class="col-sm-6 group-dropdown-align">
          <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedGroupValue"
            [settings]="singleSelectDropdownSetting" [data]="groupValueDropdown" (onSelect)="onGroupSelect($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class="col-sm-4 group-dropdown-align">
          <div class="search-button-continer">
            <button *ngIf="selectedGroupValue.length > 0" mat-stroked-button class="cancelButton resetButton"
              (click)="gridResetFunction()">
              <i class="fa fa-repeat"></i> Reset
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex detail-menu-container">
      <div id="{{ chart.id }}" class="mini-chart-container" *ngFor="let chart of charts; let ix = index"
        [ngStyle]="{'boxShadow': (hightSection == chart.status) ? 'rgb(0, 92, 138) 2px 5px 10px' : ''}">

        <div class="d-flex gap-2" (keydown.enter)="onChartClick($event, chart,'Manually')"
          (click)="onChartClick($event, chart,'Manually')"
          *ngIf="chart.status != 'My Overdue' && chart.status != 'My Active' && chart.status != 'My Total' && chart.status != 'Others' && chart.status != 'Overdue'">
          <div>
            <div class="d-flex justify-content-center align-items-center requests_menu" *ngIf="chart.status == 'Total'">
              <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                alt="total requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu closed_request"
              *ngIf="chart.status == 'Closed'">
              <img src="../../../assets/img/cr_module/closed_requests.svg" width="16px" height="16px"
                alt="closed requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu active_request"
              *ngIf="chart.status == 'Active'">
              <img src="../../../assets/img/cr_module/active_requests.svg" width="16px" height="16px"
                alt="active requests" />
            </div>
          </div>

          <div class="d-flex flex-column">
            <span class="chart-count">{{ chart.count }} </span>
            <span class="d-flex px-1">
              <span class="chart-text me-2"> {{ chart.status }} </span>
              <span class="percentage-count">{{ chart.status == "Total" ? 100 : chart.percentage }}%</span>
            </span>
            <span class="progress-bar-container"
              [ngStyle]="{'background': chart.colorCode, 'width': chart.percentage + '%'}"> </span>
          </div>
        </div>

        <div class="d-flex gap-2" (click)="onChartClick($event, chart,'Manually')" *ngIf="showAllTask"
          (keydown.enter)="onChartClick($event, chart,'Manually')">
          <div *ngIf="chart.status == 'Others' || chart.status == 'Overdue'">
            <div class="d-flex justify-content-center align-items-center requests_menu other_request"
              *ngIf="chart.status == 'Others'">
              <img src="../../../assets/img/cr_module/other_requests.svg" width="16px" height="16px"
                alt="other requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu overdue_request"
              *ngIf="chart.status == 'Overdue'">
              <img src="../../../assets/img/cr_module/overdue_request.svg" width="16px" height="16px"
                alt="overdue requests" />
            </div>
          </div>

          <div class="d-flex flex-column" *ngIf="chart.status == 'Others' || chart.status == 'Overdue'">
            <span class="chart-count"> {{ chart.count }} </span>
            <span class="d-flex px-1">
              <span class="chart-text me-2"> {{ chart.status }} </span>
              <span class="percentage-count">{{ chart.status == "Total" ? 100 : chart.percentage }}%</span>
            </span>
            <span class="progress-bar-container"
              [ngStyle]="{'background': chart.colorCode, 'width': chart.percentage + '%'}">
            </span>
          </div>
        </div>

        <div class="d-flex gap-2" (click)="onChartClick($event, chart,'Manually')" *ngIf="showMyTask"
          (keydown.enter)="onChartClick($event, chart,'Manually')">
          <div *ngIf="chart.status == 'My Overdue' || chart.status == 'My Active' || chart.status == 'My Total'">
            <div class="d-flex justify-content-center align-items-center requests_menu my_total_request"
              *ngIf="chart.status == 'My Total' ">
              <img src="../../../assets/img/cr_module/my_total.svg" width="16px" height="16px"
                alt="my total requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu my_total_request"
              *ngIf="chart.status == 'My Active'">
              <img src="../../../assets/img/cr_module/my_active.svg" width="16px" height="16px"
                alt="my total requests" />
            </div>
            <div class="d-flex justify-content-center align-items-center requests_menu my_total_request"
              *ngIf="chart.status == 'My Overdue'">
              <img src="../../../assets/img/cr_module/overdue_request.svg" width="16px" height="16px"
                alt="my overdue" />
            </div>
          </div>

          <div class="d-flex flex-column"
            *ngIf="chart.status == 'My Overdue' || chart.status == 'My Active' || chart.status == 'My Total'">
            <span class="chart-count"> {{ chart.count }} </span>
            <span class="d-flex px-1">
              <span class="chart-text me-2"> {{ chart.status }} </span>
              <span class="percentage-count">{{ chart.status == "Total" ? 100 : chart.percentage }}%</span>
            </span>
            <span class="progress-bar-container"
              [ngStyle]="{'background': chart.colorCode, 'width': chart.percentage + '%'}">
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex float-right" style="border-left: 1px solid #cfcfcf;" *ngIf="showMyFilter">
        <button
          class="justify-content-left align-items-center requests_menu my_total_request btn menu_item active border-0 outline-0 dropdown-toggle"
          type="button" style="height:40px;font-size: 12px;" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa fa-filter" width="24px" height="24px" aria-hidden="true" style="color:#005c8a"></i>
          {{chartFilter.filterName}}
          <i *ngIf="chartFilter.filterName" class="fa-solid fa-chevron-down"></i>
        </button>
        <ul class="dropdown-menu px-3 border-0 dropdown_items">
          <li class="d-flex align-items-center pt-2">
            <a class="dropdown-item px-3 dropdown_text" style="font-size: 12px;" (click)="additionalFilter(null)"
              style="border: 1px solid #cfcfcf;">
              <img src="../../../assets/img/qms_img/filter.svg" width="24px" height="24px" alt="filter">&nbsp;None</a>
          </li>
          <li *ngFor="let item of filterList" class="d-flex align-items-center pt-2" style="border: 1px solid #cfcfcf;">
            <a class="dropdown-item px-3 dropdown_text" style="font-size: 12px;" (click)="additionalFilter(item)">
              <img src="../../../assets/img/qms_img/filter.svg" width="24px" height="24px"
                alt="filter">&nbsp;{{item.filterName}}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="d-flex justify-content-between mt-3">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
          <button class="btn menu_item border border-secondary-subtle outline-0 dropdown-toggle " type="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            Export
            <i class="fa-solid fa-chevron-down ms-5"></i>
          </button>
          <ul class="dropdown-menu px-3 border-0">
            <li class="d-flex align-items-center" (click)="openReportPopup('Excel')"
              (keydown.enter)="openReportPopup('Excel')">
              <div>
                <i class="fa fa-file-excel-o"></i>
              </div>
              <span class="dropdown-item px-2 dropdown_text">Export to Excel
              </span>
            </li>
            <li class="d-flex align-items-center" (click)="openReportPopup('Pdf')"
              (keydown.enter)="openReportPopup('Pdf')">
              <div>
                <i class="fa fa-file-pdf-o"></i>
              </div>
              <span class="dropdown-item px-2 dropdown_text">Export to PDF
              </span>
            </li>
          </ul>
        </div>
        <div *ngIf="qualityService.moduleName == 'OOS'">
          Type:
        </div>
        <div style="width: 145px;" *ngIf="qualityService.moduleName == 'OOS'">
          <mat-select matInput multiple placeholder="Select" #oosMenu [(ngModel)]="oosMenuType">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isBothTypeSelected" (change)="toggleAllSelection('oosMenu')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of oosTypeDropdown| multiAssessmentSearchPipe :coreBusinesssearchTxt"
              [value]="item1.valueExp" (onSelectionChange)="onOosMenuSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" (click)="openreorder()" (keydown.enter)="openreorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="qualityService.moduleName == 'CR' && isInitiator" (click)="openAddPopup()"
          (keydown.enter)="openAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="qualityService.moduleName=='QI' && isInitiator" (click)="openQiAddPopup()"
          (keydown.enter)="openQiAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="qualityService.moduleName=='DV' && isInitiator" (click)="openDvAddPopup()"
          (keydown.enter)="openDvAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="qualityService.moduleName=='CAPA' && isInitiator" (click)="openCapaAddPopup()"
          (keydown.enter)="openCapaAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="qualityService.moduleName=='IN' && isInitiator" (click)="openInAddPopup()"
          (keydown.enter)="openInAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="qualityService.moduleName=='CC' && isInitiator" (click)="openCcAddPopup()"
          (keydown.enter)="openCcAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="qualityService.moduleName=='OOS' && isInitiator" (click)="openoosAddPopup()"
          (keydown.enter)="openoosAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>

    <div class="d-none menu-container" style="margin-top: 18px">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="gridName">{{ PageName }} ({{
            qualityService.activity.chartStatus
            }})</span>
        </div>
        <div class="col-sm-6 action-buttons-container">
          <div class="addIconContiner" *ngIf="qualityService.moduleName == 'QI' && isInitiator"
            (click)="openQiAddPopup()" (keydown.enter)="openQiAddPopup()" matTooltip=" Add Quality Issue">
            <i class="fas fa-plus"></i>
          </div>
          <div class="addIconContiner" *ngIf="qualityService.moduleName == 'DV' && isInitiator"
            (click)="openDvAddPopup()" (keydown.enter)="openDvAddPopup()" matTooltip=" Add Deviation">
            <i class="fas fa-plus"></i>
          </div>
          <div class="addIconContiner" *ngIf="qualityService.moduleName == 'CAPA' && isInitiator"
            (click)="openCapaAddPopup()" (keydown.enter)="openCapaAddPopup()" matTooltip="Add Capa">
            <i class="fas fa-plus"></i>
          </div>
          <div class="addIconContiner" *ngIf="qualityService.moduleName == 'CR' && isInitiator" (click)="openAddPopup()"
            (keydown.enter)="openAddPopup()" matTooltip="Add Change Request">
            <i class="fas fa-plus"></i>
          </div>
          <div class="addIconContiner" *ngIf="qualityService.moduleName == 'IN' && isInitiator"
            (click)="openInAddPopup()" (keydown.enter)="openInAddPopup()" matTooltip="Add Incident">
            <i class="fas fa-plus"></i>
          </div>
          <div class="addIconContiner" *ngIf="qualityService.moduleName == 'CC' && isInitiator"
            (click)="openCcAddPopup()" (keydown.enter)="openCcAddPopup()" matTooltip="Add Complaint">
            <i class="fas fa-plus"></i>
          </div>
          <div class="addIconContiner" *ngIf="qualityService.moduleName == 'OOS' && isInitiator"
            (click)="openoosAddPopup()" (keydown.enter)="openoosAddPopup()" matTooltip="Add Out Of Specification">
            <i class="fas fa-plus"></i>
          </div>
          <div class="excelIconContainer" (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')"
            matTooltip="Excel Report">
            <i class="fa fa-file-excel-o"></i>
          </div>
          <div class="pdfIconContainer" (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')"
            matTooltip="PDF Report">
            <i class="fa fa-file-pdf-o"></i>
          </div>

          <div class="reloadIconContiner" (click)="refreshGridData()" (keydown.enter)="refreshGridData()"
            matTooltip="Refresh Grid">
            <i class="fas fa-redo-alt"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="table-container mt-3">
      <table class="dynamic-table-container">
        <th [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''"></th>
        <th id="grid-header-container" (focus)="focusEmpty()"
          *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
          [ngStyle]="{'min-width':oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px'}"
          class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
          <!-- {{sortedDisplayColumn}}{{oneQmsUsersDataForTable1Data.fieldColumnarray}} -->
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
                (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
                <div>
                  <i *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='asc'"
                    class='fas fa-angle-up' style='font-size:11px'>
                  </i>
                </div>
                <div>
                  <i *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='desc'"
                    class='fas fa-angle-down' style='font-size:11px'>
                  </i>
                </div>
                <img *ngIf="sortedDisplayColumn!=oneQmsUsersDataForTable1Data.fieldColumnarray"
                  src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div>
            </div>
          </div>
        </th>
        <th id="menu" class="sticky-col first-col"></th>
        <!-- search input row is added -->
        <tr>
          <td [class]="
              makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
            "></td>
          <td class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px'            }">
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
            </div>
          </td>
        </tr>
        <!-- data row -->
        <tr *ngFor="
            let list of pagedItems | searchFilter : searchValue;
            let idx = index
          " [class.highlightRow]="list.childCheckBoxs == true">
          <td style="min-width: 60px; text-align: center;background: white;" [class]="
              makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
            ">
            <div style="display: flex">
              <div [ngClass]="
                  list.childCheckBoxs ? 'static_icon' : 'hover-menu-icons'
                ">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2" [checked]="list.childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)" />
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" (focus)="focusEmpty()"
            [ngStyle]="{'max-width': key.width[i] != null ? key.width[i] : '200px', overflow: 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
            (click)="navigateToDetails(list, i)" (keydown.enter)="navigateToDetails(list, i)"
            (mouseover)="cssfunction(i)" matTooltipClass="tooltip-withoutbreak"
            [matTooltip]="getToolTip(list[key.columnsListarray])">
            <span *ngIf="key.dataType == 'CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
                  height="16" alt="access" />
                <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
                  width="16" height="16" alt="no access" />
              </div>
            </span>
            <span
              *ngIf="key.dataType != 'CHECKBOX' && key.dataType != 'DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' "
              [ngStyle]="{
                color:
                  key.columnsListarray == 'STATUS' &&
                  (list[key.columnsListarray].includes('Rejected') ||
                    list[key.columnsListarray].includes('Deleted') ||
                    list[key.columnsListarray].includes('Obsoleted'))
                    ? '#FF3A29'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('Open') ||
                        list[key.columnsListarray].includes('Draft') ||
                        list[key.columnsListarray].includes('Scheduled') ||
                        list[key.columnsListarray].includes('Initiated'))
                    ? '#FF8900'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('Closed') ||
                        list[key.columnsListarray].includes('Completed') ||
                        list[key.columnsListarray].includes('Approved'))
                    ? '#00E58F'
                    : i == 0
                    ? '#07426A'
                    : '#0f3659',
                background:
                  key.columnsListarray == 'STATUS' &&
                  (list[key.columnsListarray].includes('Rejected') ||
                    list[key.columnsListarray].includes('Deleted') ||
                    list[key.columnsListarray].includes('Obsoleted'))
                    ? '##FF3A291A'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('Open') ||
                        list[key.columnsListarray].includes('Draft') ||
                        list[key.columnsListarray].includes('Scheduled') ||
                        list[key.columnsListarray].includes('Initiated'))
                    ? '#FF89001A'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('Closed') ||
                        list[key.columnsListarray].includes('Completed') ||
                        list[key.columnsListarray].includes('Approved'))
                    ? '#00E58F1A'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('QA Accepted') ||
                        list[key.columnsListarray].includes(
                          'Owner Acknowledged'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Approval'
                        ) ||
                        list[key.columnsListarray].includes('In Progress') ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Review'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending QA Acceptance'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Obsolete Approval'
                        ))
                    ? '#005C8A1A'
                    : i == 0
                    ? ''
                    : '',
                border:
                  key.columnsListarray == 'STATUS' &&
                  (list[key.columnsListarray].includes('Rejected') ||
                    list[key.columnsListarray].includes('Deleted') ||
                    list[key.columnsListarray].includes('Obsoleted'))
                    ? '0.75px solid #FF3A29'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('Open') ||
                        list[key.columnsListarray].includes('Draft') ||
                        list[key.columnsListarray].includes('Scheduled') ||
                        list[key.columnsListarray].includes('Initiated'))
                    ? '0.75px solid #FF8900'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('Closed') ||
                        list[key.columnsListarray].includes('Completed') ||
                        list[key.columnsListarray].includes('Approved'))
                    ? '0.75px solid #00E58F'
                    : key.columnsListarray == 'STATUS' &&
                      (list[key.columnsListarray].includes('QA Accepted') ||
                        list[key.columnsListarray].includes(
                          'Owner Acknowledged'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Approval'
                        ) ||
                        list[key.columnsListarray].includes('In Progress') ||
                        list[key.columnsListarray].includes(
                          'Pending Closure Review'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending QA Acceptance'
                        ) ||
                        list[key.columnsListarray].includes(
                          'Pending Obsolete Approval'
                        ))
                    ? '0.75px solid #005C8A1A'
                    :key.columnsListarray == 'STATUS'
                    ?'0.75px solid #0f3659'
                    : i == 0
                    ? ''
                    : '',
                'font-family':
                  key.columnsListarray == 'STATUS' ? 'Poppins' : '',
                'border-radius': '6px',
                padding: '3px 9px'
              }">{{ list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType == 'DATE'">{{
              list[key.columnsListarray]
              }}</span>

            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray,columnLists.fieldColumnarray[i].fieldColumnarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
          </td>
          <td class="sticky-col first-col">
            <div class="action-icons">
              <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
                *ngIf="message.isAuditTrailUser" (click)="openAuditTrail(list)"
                (keydown.enter)="openAuditTrail(list)"></i>
            </div>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #searchManager>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div id="filed-container" class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="searchByDesignationCode"
          [settings]="singleSelectDropdownSetting" [data]="designationCodeDropdown">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="departmentCode"
          [settings]="singleSelectDropdownSetting" [data]="departmentCodeDropdown">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchManagerGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchManagerGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input type="checkbox" style="zoom: 1.2;" [checked]="searchManagerParentCheckBox"
                (change)="searchManagerDataGridParentCheckBoxChecked($event)">
            </div>
          </div>
        </th>
        <th> <span>User Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>First Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Last Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>User Full Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Designation</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Department</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>EmailAddress</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Contact Number</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Manager Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Is Ad User</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Is Factory User</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Is Active</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                  (change)="searchManagerChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.contactNumber }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isAdUser"> </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isFactoryUser"> </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isActive"> </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addManagerNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #crAddAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer" style="max-height: 470px !important;">
      <div class="row field-row">
        <div class="col-md-3">
          <div><label for="email ">Group</label></div>
          <input class="cr_id input-filed-continers" type="text" [(ngModel)]="selectedGroupValue[0].displayExp"
            disabled>
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable=='Y'">
          <div><label id="department-validation" for="email">{{dynamicLabel['DEPT_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="departmentCode" (closed)="deptsearchTxt=''"
            (click)="focusmethod('departmentfocusSearch')" (keydown.enter)="focusmethod('departmentfocusSearch')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="deptsearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :deptsearchTxt"
              (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div><label id="owner-validation" for="email">{{dynamicLabel['OWNER_USER_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['OWNER_USER_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="ownerValue" (closed)="ownersearchTxt=''"
            (click)="focusmethod('ownerfocusSearch')" (keydown.enter)="focusmethod('ownerfocusSearch')">
            <input type="search" id="ownerfocusSearch" class="dropdownsearchstyle" [(ngModel)]="ownersearchTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of ownersListDropdown| assessmentSearch :ownersearchTxt"
              (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp"
              [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div><label id="changeType-validation" for="email">{{dynamicLabel['CHANGE_TYPE_CODE'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['CHANGE_TYPE_CODE'].fieldNotes"
              [matTooltip]="dynamicLabel['CHANGE_TYPE_CODE'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="changeTypeValue" (closed)="changeTypesearchTxt=''"
            (click)="focusmethod('changeTypefocusSearch')" (keydown.enter)="focusmethod('changeTypefocusSearch')">
            <input type="search" id="changeTypefocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="changeTypesearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of changeTypeDropdown| assessmentSearch :changeTypesearchTxt"
              (onSelectionChange)="onchangeTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="row field-row">
        <div class="col-md-3">
          <div><label id="requestedAt-validation" for="email">{{dynamicLabel['REQUESTED_AT'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
              [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="requestedAtValue" (closed)="requestedAtsearchTxt=''"
            (click)="focusmethod('requestedAtfocusSearch')" (keydown.enter)="focusmethod('requestedAtfocusSearch')">
            <input type="search" id="requestedAtfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="requestedAtsearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onRequestedAtSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of RequestedAtDropdown| assessmentSearch :requestedAtsearchTxt"
              (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6">
          <div><label id="coreBusinessArea-validation" for="email">
              {{((this.bussinessAreaName ?? '' ) + ' ' + dynamicLabel['CORE_BUSINESS_AREA_NAME'].fieldName)}}
            </label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple placeholder="Select" #allcoreBusinesss [(ngModel)]="coreBusinessAreaNameValue"
            *ngIf="coreBusinessAreaNameDropdown.length>0" (closed)="coreBusinesssearchTxt=''"
            [matTooltip]="coreBusinessAreaNameValue" (click)="focusmethod('coreBusinessfocusSearch')"
            (keydown.enter)="focusmethod('coreBusinessfocusSearch')">
            <input type="search" id="coreBusinessfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="coreBusinesssearchTxt" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="allcoreBusinesssSelected"
                (change)="toggleAllSelection1('allcoreBusinesssSelected')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of coreBusinessAreaNameDropdown| multiAssessmentSearchPipe :coreBusinesssearchTxt"
              [value]="item1.valueExp" (onSelectionChange)="onCoreBusinessAreaNameSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            *ngIf="coreBusinessAreaNameDropdown.length==0" [(ngModel)]="coreBusinessAreaNameValue"
            (input)="limitCharacters($event, 'REQUESTED_AT')"></textarea>
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable=='Y'">
          <div><label id="expectedToBeStartedOn-validation"
              for="email">{{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsCRData.expectedToBeStartedOn"
            (ngModelChange)="changeexpectedToBeStartedOnDate($event); onExpectedToBeStartedOnChange()"
            [disabled]="qmsCRData.expectedClosureFromSettings=='Y'">
        </div>
        <div class="col-md-3">
          <div><label id="expcetedClosureOn-validation"
              for="email">{{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsCRData.expcetedClosureOn" (ngModelChange)="changeExpcetedClosureOnDate($event)">
        </div>


        <div class="col-md-3 field-row"
          *ngIf="this.qualityService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
          <div><label for="email">{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"
              [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="qmsCRData.effectivenessCheckReqd">
            <span *ngIf="qmsCRData.effectivenessCheckReqd==true"
              [ngStyle]="qmsCRData.effectivenessCheckReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="qmsCRData.effectivenessCheckReqd==false"
              [ngStyle]="qmsCRData.effectivenessCheckReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3 field-row" *ngIf="showChangeTypeIfNa">
          <div><label for="email ">Change Type if NA</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsCRData.changeTypeIfNa">
        </div>
        <div class="col-md-6 field-row">
          <div><label id="shortDescription-validation"
              for="email">{{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}</label><span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input class="input-filed-continers shortDescription" type="text" placeholder="" maxlength="400"
            [(ngModel)]="qmsCRData.shortDescription">
        </div>
      </div>

      <div class="row field-row">
        <div class="col-md-6" [hidden]="dynamicLabel['CHANGE_DESCRIPTION'].isRemovable=='Y'">
          <div><label id="changeDescription-validation"
              for="email">{{dynamicLabel['CHANGE_DESCRIPTION'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['CHANGE_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['CHANGE_DESCRIPTION'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="qmsCRData.changeDescription" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit">
              <i class="far fa-edit" (click)="openEditor('Change Description')"
                (keydown.enter)="openEditor('Change Description')"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6" [hidden]="dynamicLabel['CHANGE_JUSTIFICATION'].isRemovable=='Y'">
          <div><label id="changeJustification-validation"
              for="email">{{dynamicLabel['CHANGE_JUSTIFICATION'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['CHANGE_JUSTIFICATION'].fieldNotes"
              [matTooltip]="dynamicLabel['CHANGE_JUSTIFICATION'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="qmsCRData.changeJustification" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit">
              <i class="far fa-edit" (click)="openEditor('Change Justification')"
                (keydown.enter)="openEditor('Change Justification')"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="row field-row">
        <div class="col-md-6" [hidden]="dynamicLabel['REASON_FOR_CHANGE_CODE'].isRemovable=='Y'">
          <div><label id="reasonForChange-validation"
              for="email">{{dynamicLabel['REASON_FOR_CHANGE_CODE'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_CHANGE_CODE'].fieldNotes"
              [matTooltip]="dynamicLabel['REASON_FOR_CHANGE_CODE'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <mat-select matInput multiple #reasonForChange placeholder="Select" [(ngModel)]="reasonForChangeValue"
            (closed)="reasonForChangesearchTxt=''" (click)="focusmethod('focusSearch')"
            (keydown.enter)="focusmethod('focusSearch')">
            <input type="search" id="focusSearch" class="dropdownsearchstyle" [(ngModel)]="reasonForChangesearchTxt"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="allSelected" (change)="toggleAllSelection1('reasonForChange')">Select
                All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of reasonForChangeDropdown| multiAssessmentSearchPipe :reasonForChangesearchTxt"
              [value]="item1.valueExp" (onSelectionChange)="onReasonForChangeSelect1($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>

        </div>
        <div class="col-md-6"
          *ngIf="visibleReasonForChangeIfOthers && dynamicLabel['REASON_FOR_CHANGE_CODE'].isRemovable != 'Y'">
          <div><label id="reasonForChangeIfOthers-validation"
              for="email">{{dynamicLabel['REASON_FOR_CHANGE_CODE'].fieldName}} If Others</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="reasonForChangeIfOthers" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="qmsCRData.reasonForChange"></textarea>
        </div>
        <div class="col-md-2" *ngIf="this.qualityService.selectedGroupDetailData.isRiskCalculationReqd=='Y'">
          <div><label for="email">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
              [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="qmsCRData.isRiskCalculationReqd">
            <span *ngIf="qmsCRData.isRiskCalculationReqd==true"
              [ngStyle]="qmsCRData.isRiskCalculationReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="qmsCRData.isRiskCalculationReqd==false"
              [ngStyle]="qmsCRData.isRiskCalculationReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="form-template ActivityPage">
        <app-flexible-fields #flexible [from]="'Master'"></app-flexible-fields>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(qmsCRData)" (keydown.enter)="addAndEditFunction(qmsCRData)"
      *ngIf="!visibleEditButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #addAndEditOOSPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer" style="max-height: 470px !important;">
      <div class="row field-row">
        <div class="col-md-3">
          <div><label for="email">Group</label></div>
          <input class="cr_id input-filed-continers" type="text" [(ngModel)]="selectedGroupValue[0].displayExp"
            disabled>
        </div>
        <div class="col-md-3">
          <div>
            <label id="oost-type-validation" for="email">
              {{dynamicLabel['OOST_TYPE'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['OOST_TYPE'].fieldNotes"
              [matTooltip]="dynamicLabel['OOST_TYPE'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="oos.oostType" (closed)="typeSearchText=''"
            (click)="focusSearch('type-search')" (keydown.enter)="focusSearch('type-search')">
            <input type="search" id="type-search" class="dropdownsearchstyle" [(ngModel)]="typeSearchText" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of oosTypeDropdown| assessmentSearch :typeSearchText"
              (onSelectionChange)="onOostTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['INITIATING_DEPT_NAME'].isRemovable=='Y'">
          <div>
            <label id="initiating-department-validation"
              for="email">{{dynamicLabel['INITIATING_DEPT_NAME'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['INITIATING_DEPT_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['INITIATING_DEPT_NAME'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="oos.initiatingDeptCode"
            (closed)="initiatingdeptsearchTxt=''" (click)="focusmethod('initiating-dept-search')"
            (keydown.enter)="focusmethod('initiating-dept-search')">
            <input type="search" id="initiating-dept-search" class="dropdownsearchstyle"
              [(ngModel)]="initiatingdeptsearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :initiatingdeptsearchTxt"
              (onSelectionChange)="onOosInitiatingDepartmentSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['OOS_DEPT_NAME'].isRemovable=='Y'">
          <div>
            <label id="oos-department-validation" for="email">
              {{oos.oostType}}&nbsp;{{dynamicLabel['OOS_DEPT_NAME'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['OOS_DEPT_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['OOS_DEPT_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="oos.oosDeptCode" (closed)="deptsearchTxt=''"
            (click)="focusmethod('departmentfocusSearch')" (keydown.enter)="focusmethod('departmentfocusSearch')">
            <input type=" search" id="departmentfocusSearch" class="dropdownsearchstyle" [(ngModel)]="deptsearchTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :deptsearchTxt"
              (onSelectionChange)="onOosDepartmentSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div>
            <label id="oos-owner-validation" for="email">
              {{dynamicLabel['OWNER_USER_NAME'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['OWNER_USER_NAME'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="oos.owner" (closed)="ownersearchTxt=''"
            (click)="focusmethod('ownerfocusSearch')" (keydown.enter)="focusmethod('ownerfocusSearch')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="ownersearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of ownersListDropdown| assessmentSearch :ownersearchTxt"
              (onSelectionChange)="onOosOwnerSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div>
            <label id="oos-occurrence-validation" for="oos-occurrence">
              {{dynamicLabel['DATE_OF_OCCURRENCE'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['DATE_OF_OCCURRENCE'].fieldNotes"
              [matTooltip]="dynamicLabel['DATE_OF_OCCURRENCE'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$past_present_config"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="oos.dateOfOccurrence"
            (ngModelChange)="onOosOccurrenceChange($event); onNgModuleChange(oos.dateOfOccurrence, 'oos-occurrence-validation')">
        </div>
        <div class="col-md-3">
          <div>
            <label id="oos-identified-on-validation" for="oos-identified-on">
              {{dynamicLabel['IDENTIFIED_ON'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['IDENTIFIED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['IDENTIFIED_ON'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="$identified_on_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="oos.identifiedOn"
            (ngModelChange)="onNgModuleChange(oos.identifiedOn, 'oos-identified-on-validation')"
            [disabled]="!oos.dateOfOccurrence">
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable=='Y'">
          <div>
            <label id="oos-started-on-validation" for="email">{{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="oos.expectedToBeStartedOn"
            (ngModelChange)="changeexpectedToBeStartedOnDate($event); onExpectedToBeStartedOnChange(); onNgModuleChange(oos.expectedToBeStartedOn, 'oos-started-on-validation')">
        </div>
        <div class="col-md-3">
          <div>
            <label id="oos-closure-on-validation" for="email">
              {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="oos.expcetedClosureOn"
            (ngModelChange)="changeExpcetedClosureOnDate($event); onNgModuleChange(oos.expcetedClosureOn, 'oos-closure-on-validation')">
        </div>
      </div>
      <div class="form-template ActivityPage">
        <app-flexible-fields #flexible [from]="'Master'"></app-flexible-fields>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="createOos(oos)"
      *ngIf="!visibleEditButton" (keydown.enter)="createOos(oos)">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelOOSAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #capaAddPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="capaCancelPopupFuntion()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer" style="max-height: 470px !important;">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email ">Group</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="selectedGroupValue[0].displayExp" disabled>
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable=='Y'">
          <div><label id="capaDepartment-validation" for="email">{{dynamicLabel['DEPT_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCapaDepartmentValue"
            (closed)="deptsearchTxt=''" (click)="focusmethod('departmentfocusSearch')"
            (keydown.enter)="focusmethod('departmentfocusSearch')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="deptsearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of capaDepartmentCodeDropdown| assessmentSearch :deptsearchTxt"
              (onSelectionChange)="onCapaDepartmentCodeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" id="search-container">
          <div><label id="capaOwner-validation" for="email">{{dynamicLabel['OWNER_USER_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['OWNER_USER_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCapaOwnerValue" (closed)="ownersearchTxt=''"
            (click)="focusmethod('focus-capa-owner')" (keydown.enter)="focusmethod('focus-capa-owner')">
            <input type="search" id="focus-capa-owner" class="dropdownsearchstyle" [(ngModel)]="ownersearchTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of capaOwnersListDropdown| assessmentSearch :ownersearchTxt"
              (onSelectionChange)="onCapaOwnerSelect($event,item)" [value]="item.valueExp"
              [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div><label id="capaType-validation" for="email">{{dynamicLabel['CAPA_TYPE'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['CAPA_TYPE'].fieldNotes"
              [matTooltip]="dynamicLabel['CAPA_TYPE'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCapaTypeValue" (closed)="capaTypesearchTxt=''"
            (click)="focusmethod('capa-type-search')" (keydown.enter)="focusmethod('capa-type-search')">
            <input type="search" id="capa-type-search" class="dropdownsearchstyle" [(ngModel)]="capaTypesearchTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of capaTypeDropdown| assessmentSearch :capaTypesearchTxt"
              (onSelectionChange)="onCapaTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3 field-row">
          <div><label id="capaRequestedAt-validation"
              for="email">{{dynamicLabel['REQUESTED_AT'].fieldName}}</label><span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
              [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCapaRequestedAtValue"
            (closed)="requestedAtsearchTxt=''" (click)="focusmethod('capa-requested-at')"
            (keydown.enter)="focusmethod('capa-requested-at')">
            <input type="search" id="capa-requested-at" class="dropdownsearchstyle" [(ngModel)]="requestedAtsearchTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onCapaRequestedAtSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of capaRequestedAtDropdown| assessmentSearch :requestedAtsearchTxt"
              (onSelectionChange)="onCapaRequestedAtSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6 field-row" *ngIf="selectedCapaRequestedAtValue">
          <div><label id="capaCoreBusinessArea-validation" for="email">{{((this.bussinessAreaName ?? '' )+ ' ' +
              dynamicLabel['CORE_BUSINESS_AREA_NAME'].fieldName)}}</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple #allcoreBusinesssCapa placeholder="Select"
            *ngIf="capaCoreBusinessAreaNameDropdown.length>0" [(ngModel)]="selectedCapaCoreBusinessAreaNameValue"
            [matTooltip]="selectedCapaCoreBusinessAreaNameValue" (closed)="coreBusinesssearchTxt=''"
            (click)="focusmethod('coreBusinessfocusSearch')" (keydown.enter)="focusmethod('coreBusinessfocusSearch')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="coreBusinesssearchTxt" matInput
              placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="allcoreBusinesssSelectedCapa"
                (change)="toggleAllSelection1('allcoreBusinesssSelectedCapa')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of capaCoreBusinessAreaNameDropdown| multiAssessmentSearchPipe :coreBusinesssearchTxt"
              [value]="item1.valueExp" (onSelectionChange)="onCapaCoreBusinessAreaNameSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            *ngIf="capaCoreBusinessAreaNameDropdown.length==0" [(ngModel)]="selectedCapaCoreBusinessAreaNameValue"
            (input)="limitCharacters($event, 'REQUESTED_AT')"></textarea>

        </div>
        <div class="col-md-3 field-row" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable=='Y'">
          <div><label id="capaExpcetedToStarted-validation"
              for="email">{{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsCapaFieldData.expectedToBeStartedOn"
            (ngModelChange)="capaExpectedToBeStartedOnDate($event); onExpectedToBeStartedOnChange()">
        </div>
        <div class="col-md-3 field-row">
          <div><label id="capaExpcetedClosureOn-validation"
              for="email">{{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsCapaFieldData.expcetedClosureOn" (ngModelChange)="capaExpcetedClosureOnDate($event)">
        </div>
        <div class="col-md-3 field-row" style="display: flex;">
          <div class="col-md-5 field-row"
            *ngIf="this.qualityService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
            <div><label for="email ">{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}</label>
              <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"
                [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"><img [src]="qualityService.noteIcon"
                  alt="note" width="18" height="18"></span>
            </div>
            <mat-slide-toggle color="primary" [(ngModel)]="qmsCapaFieldData.effectivenessCheckReqd">
              <span class="active-inActive-container" *ngIf="qmsCapaFieldData.effectivenessCheckReqd==true"
                [ngStyle]="qmsCapaFieldData.effectivenessCheckReqd==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
              <span *ngIf="qmsCapaFieldData.effectivenessCheckReqd==false"
                [ngStyle]="qmsCapaFieldData.effectivenessCheckReqd==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>
        </div>
        <div class="col-md-6 field-row">
          <div><label id="capaShortDescription-validation"
              for="email">{{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}<span class="mandatory-symbol">*</span></label>
            <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsCapaFieldData.shortDescription"
            maxlength="400" (focusout)="onCapaFieldFocusout()">
        </div>
        <div class="col-md-6 field-row">
          <div><label id="capaDescription-validation"
              for="email">{{dynamicLabel['CAPA_DESCRIPTION'].fieldName}}</label><span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['CAPA_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['CAPA_DESCRIPTION'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <div class="hideToolbar">
            <div class="row">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsCapaFieldData.capaDescription" [config]="config" [spellcheck]="true"
                  (paste)="onPaste($event)" (focusout)="onCapaFieldFocusout()"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit">
                <i class="far fa-edit" (click)="openEditor('CAPA Description')"
                  (keydown.enter)="openEditor('CAPA Description')"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 field-row" [hidden]="dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable=='Y'">
          <div><label id="reasonForCapa-validation"
              for="email">{{dynamicLabel['REASON_FOR_CAPA_CODE'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_CAPA_CODE'].fieldNotes"
              [matTooltip]="dynamicLabel['REASON_FOR_CAPA_CODE'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <mat-select matInput multiple #reasonForCapa placeholder="Select" [(ngModel)]="selectedReasonForCapaValue"
            (closed)="reasonForChangesearchTxt=''" (click)="focusmethod('r-f-c')"
            (keydown.enter)="focusmethod('r-f-c')">
            <input type="search" id="r-f-c" class="dropdownsearchstyle" [(ngModel)]="reasonForChangesearchTxt" matInput
              placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="allSelectedCapa" (change)="toggleAllSelection1('reasonForCapa')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of reasonForCapaDropdown| multiAssessmentSearchPipe :reasonForChangesearchTxt"
              [value]="item1.valueExp" (onSelectionChange)="onReasonForCapaSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6 field-row"
          *ngIf="visibleReasonForCapaIfOthers && dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable != 'Y'">
          <div><label id="reasonForChangeIfOthers-validation"
              for="email">{{dynamicLabel['REASON_FOR_CAPA_CODE'].fieldName}} If
              Others</label><span class="mandatory-symbol">*</span></div>
          <textarea id="reasonForChangeIfOthers" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="qmsCapaFieldData.reasonForCapa"></textarea>
        </div>
        <div class="col-md-2 field-row" *ngIf="this.qualityService.selectedGroupDetailData.isRiskCalculationReqd=='Y'">
          <div><label for="email">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
              [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="qmsCapaFieldData.isRiskCalculationReqd">
            <span *ngIf="qmsCapaFieldData.isRiskCalculationReqd==true"
              [ngStyle]="qmsCapaFieldData.isRiskCalculationReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="qmsCapaFieldData.isRiskCalculationReqd==false"
              [ngStyle]="qmsCapaFieldData.isRiskCalculationReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="form-template ActivityPage">
        <app-flexible-fields #flexible [from]="'Master'"></app-flexible-fields>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="capaSaveButtonFuntion(qmsCapaFieldData)" (keydown.enter)="capaSaveButtonFuntion(qmsCapaFieldData)">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="capaCancelPopupFuntion()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #dvAddPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="dvCancelPopupFuntion()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer" style="max-height: 470px !important;">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email ">Group</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="selectedGroupValue[0].displayExp" disabled>
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable=='Y'">
          <div><label id="dvDepartment-validation" for="email">{{dynamicLabel['DEPT_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedDvDepartmentValue" (closed)="deptsearchTxt=''"
            (click)="focusmethod('departmentfocusSearch')" (keydown.enter)="focusmethod('departmentfocusSearch')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="deptsearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of dvDepartmentCodeDropdown| assessmentSearch :deptsearchTxt"
              (onSelectionChange)="onDvDepartmentCodeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" id="search-container">
          <div><label id="dvOwner-validation" for="email">{{dynamicLabel['OWNER_USER_NAME'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['OWNER_USER_NAME'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedDvOwnerValue" (closed)="ownersearchTxt=''"
            (click)="focusmethod('ownerfocusSearch')" (keydown.enter)="focusmethod('ownerfocusSearch')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="ownersearchTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of dvOwnersListDropdown| assessmentSearch :ownersearchTxt"
              (onSelectionChange)="onDvOwnerSelect($event,item)" [value]="item.valueExp"
              [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['DEVIATION_TYPE'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['DEVIATION_TYPE'].fieldNotes"
              [matTooltip]="dynamicLabel['DEVIATION_TYPE'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedDvTypeValue" (closed)="dvTypesearchTxt=''"
            (click)="focusmethod('changeTypefocusSearch')" (keydown.enter)="focusmethod('changeTypefocusSearch')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="dvTypesearchTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of dvTypeDropdown| assessmentSearch :dvTypesearchTxt"
              (onSelectionChange)="onDvTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" [hidden]="dynamicLabel['DEVIATION_CRITICALITY']?.isRemovable=='Y'">
          <div>
            <label id="dv-criticality" for="email">
              {{dynamicLabel['DEVIATION_CRITICALITY'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['DEVIATION_CRITICALITY'].fieldNotes"
              [matTooltip]="dynamicLabel['DEVIATION_CRITICALITY'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="qmsDvFieldData.deviationCriticality"
            (closed)="criticalitySearchText=''" (click)="focusSearch('focus-criticality')"
            (keydown.enter)="focusmethod('focus-criticality')">
            <input type="search" id="focus-criticality" class="dropdownsearchstyle" [(ngModel)]="criticalitySearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onDeviationCriticalitySelect($event, null)">Un-select</mat-option>
            <mat-option *ngFor="let item of dvCriticalityDropdown | assessmentSearch :criticalitySearchText"
              (onSelectionChange)="onDeviationCriticalitySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3 field-row">
          <div><label id="dvRequestedAt-validation" for="email">{{dynamicLabel['REQUESTED_AT'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
              [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                width="18" height="18"></span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="dvRequestedAtValue" (closed)="requestedAtsearchTxt=''"
            (click)="focusmethod('dv-reauested-at')" (keydown.enter)="focusmethod('dv-reauested-at')">
            <input type="search" id="dv-reauested-at" class="dropdownsearchstyle" [(ngModel)]="requestedAtsearchTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onDvRequestedAtSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of dvRequestedAtDropdown| assessmentSearch :requestedAtsearchTxt"
              (onSelectionChange)="onDvRequestedAtSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6 field-row" *ngIf="dvRequestedAtValue">
          <div><label id="dvCoreBusinessArea-validation" for="email">{{((this.bussinessAreaName ?? '' )+ ' ' +
              dynamicLabel['CORE_BUSINESS_AREA_NAME'].fieldName)}}</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple #allcoreBusinesssDv placeholder="Select"
            *ngIf="dvCoreBusinessAreaNameDropdown.length>0" [(ngModel)]="dvCoreBusinessAreaNameValue"
            [matTooltip]="dvCoreBusinessAreaNameValue" (closed)="reasonForChangesearchTxt=''"
            (click)="focusmethod('dv-c-b-a')" (keydown.enter)="focusmethod('dv-c-b-a')">
            <input type="search" id="dv-c-b-a" cldv-c-b-aass="dropdownsearchstyle"
              [(ngModel)]="reasonForChangesearchTxt" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="allcoreBusinesssSelectedDv"
                (change)="toggleAllSelection1('allcoreBusinesssSelectedDv')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of dvCoreBusinessAreaNameDropdown| multiAssessmentSearchPipe :reasonForChangesearchTxt"
              [value]="item1.valueExp" (onSelectionChange)="onDvCoreBusinessAreaNameSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            *ngIf="dvCoreBusinessAreaNameDropdown.length==0" [(ngModel)]="dvCoreBusinessAreaNameValue"
            (input)="limitCharacters($event, 'REQUESTED_AT')"></textarea>
        </div>
        <div class="col-md-3 field-row" [hidden]="dynamicLabel['DEVIATION_OCCURED_ON'].isRemovable=='Y'">
          <div>
            <label id="deviationOccuredOn-validation" for="dv-occurred-on">
              {{dynamicLabel['DEVIATION_OCCURED_ON'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['DEVIATION_OCCURED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['DEVIATION_OCCURED_ON'].fieldNotes"><img [src]="qualityService.noteIcon"
                alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$past_present_config"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qmsDvFieldData.deviationOccuredOn"
            (ngModelChange)="changedDeviationOccuredOnDate($event)">
        </div>
        <div class="col-md-3 field-row" [hidden]="dynamicLabel['DEVIATION_IDENTIFIED_ON'].isRemovable=='Y'">
          <div>
            <label id="deviationIdentifiedOn-validation" for="dv-identified-on">
              {{dynamicLabel['DEVIATION_IDENTIFIED_ON'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['DEVIATION_IDENTIFIED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['DEVIATION_IDENTIFIED_ON'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <input id="dv-identified-on" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="$identified_on_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsDvFieldData.deviationIdentifiedOn" (ngModelChange)="changeDeviationIdentifiedOnDate($event)"
            [disabled]="!qmsDvFieldData.deviationOccuredOn">
        </div>
        <div class="col-md-3 field-row" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable=='Y'">
          <div>
            <label id="expectedToBeStartedOn-validation" for="dv-expected-to-started-on">
              {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$present_future_config"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qmsDvFieldData.expectedToBeStartedOn"
            (ngModelChange)="changeDvExpectedToBeStartedOnDate($event); onExpectedToBeStartedOnChange()">
        </div>
        <div class="col-md-3 field-row">
          <div>
            <label id="dvExpcetedClosureOn-validation" for="dv-closure-on">
              {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsDvFieldData.expcetedClosureOn" (ngModelChange)="changeDvExpcetedClosureOnDate($event)">
        </div>
        <div class="col-md-3 field-row"
          *ngIf="this.qualityService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
          <div><label for="email">{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"
              [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="qmsDvFieldData.effectivenessCheckReqd">
            <span class="active-inActive-container" *ngIf="qmsDvFieldData.effectivenessCheckReqd==true"
              [ngStyle]="qmsDvFieldData.effectivenessCheckReqd==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
            <span *ngIf="qmsDvFieldData.effectivenessCheckReqd==false"
              [ngStyle]="qmsDvFieldData.effectivenessCheckReqd==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-6 field-row">
          <div><label id="dvShortDescription-validation"
              for="email">{{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}<span class="mandatory-symbol">*</span></label>
            <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsDvFieldData.shortDescription" maxlength="400"
            (focusout)="onDvFieldFocusout()">
        </div>
        <div class="col-md-6 field-row">
          <div class="row"><label id="dvDescription-validation"
              for="email ">{{dynamicLabel['DV_DESCRIPTION'].fieldName}}<span class="mandatory-symbol">*</span> </label>
            <span style="float:right" *ngIf="dynamicLabel['DV_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['DV_DESCRIPTION'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <div class="hideToolbar">
            <div class="row">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsDvFieldData.dvDescription" [config]="config" [spellcheck]="true"
                  (paste)="onPaste($event)" (focusout)="onDvFieldFocusout()"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit">
                <i class="far fa-edit" (click)="openEditor('Deviation Description')"
                  (keydown.enter)="openEditor('Deviation Description')"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 field-row" *ngIf="dynamicLabel['REASON_FOR_DEVIATION_CODE'].isRemovable !=='Y'">
          <div><label id="reasonForDeviation-validation"
              for="email">{{dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldName}}</label><span
              class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldNotes"
              [matTooltip]="dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldNotes">
              <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
          </div>
          <mat-select matInput multiple #reasonForDv placeholder="Select" [(ngModel)]="reasonForDeviationValue"
            (closed)="reasonForChangesearchTxt=''" (click)="focusmethod('dv-r-f-c')"
            (keydown.enter)="focusmethod('dv-r-f-c')">
            <input type="search" id="dv-r-f-c" class="dropdownsearchstyle" [(ngModel)]="reasonForChangesearchTxt"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="allSelectedDv" (change)="toggleAllSelection1('reasonForDv')">Select
                All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of reasonForDeviationDropdown| multiAssessmentSearchPipe :reasonForChangesearchTxt"
              [value]="item1.valueExp" (onSelectionChange)="onReasonForDeviationSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6 field-row"
          *ngIf="visibleReasonForDivationIfOthers && dynamicLabel['REASON_FOR_DEVIATION_CODE'].isRemovable != 'Y'">
          <div><label id="reasonForChangeIfOthers-validation"
              for="email">{{dynamicLabel['REASON_FOR_DEVIATION_CODE'].fieldName}} If Others</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="reasonForChangeIfOthers" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="qmsDvFieldData.reasonForDeviation"></textarea>
        </div>
        <div class="col-md-3 field-row" *ngIf="this.qualityService.selectedGroupDetailData.isRiskCalculationReqd=='Y'">
          <div><label for="email">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="qmsDvFieldData.isRiskCalculationReqd">
            <span *ngIf="qmsDvFieldData.isRiskCalculationReqd==true"
              [ngStyle]="qmsDvFieldData.isRiskCalculationReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="qmsDvFieldData.isRiskCalculationReqd==false"
              [ngStyle]="qmsDvFieldData.isRiskCalculationReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="form-template ActivityPage">
        <app-flexible-fields #flexible [from]="'Master'"></app-flexible-fields>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="dvSaveButtonFuntion(qmsDvFieldData)" (keydown.enter)="dvSaveButtonFuntion(qmsDvFieldData)">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="dvCancelPopupFuntion()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #qiAddPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="qiCancelPopupFuntion()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer" style="max-height: 490px !important;">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email ">Group</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="selectedGroupValue[0].displayExp" disabled>
        </div>
        <div class="col-md-3">
          <div>
            <!-- Quality Issue Type  -->
            <label id="qi-type-validation" for="qi-type">
              {{dynamicLabel['QI_TYPE'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['QI_TYPE'].fieldNotes"
              [matTooltip]="dynamicLabel['QI_TYPE'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedQiType" (closed)="qiTypeSearchText=''"
            (click)="focusmethod('focus-type-search')" (keydown.enter)="focusmethod('focus-type-search')">
            <input type="search" id="focus-type-search" class="dropdownsearchstyle" [(ngModel)]="qiTypeSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onQiTypeSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of qiTypeDropdown | assessmentSearch : qiTypeSearchText"
              (onSelectionChange)="onQiTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable == 'Y'">
          <div>
            <!-- Department -->
            <label id="qi-department-validation" for="qi-department">
              {{dynamicLabel['DEPT_NAME'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedQiDepartment"
            (closed)="qiDepartmentSearchText=''" (click)="focusmethod('focus-department-search')"
            (keydown.enter)="focusmethod('focus-department-search')">
            <input type="search" id="focus-department-search" class="dropdownsearchstyle"
              [(ngModel)]="qiDepartmentSearchText" matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onQiDepartmentSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of qiDepartmentCodeDropdown | assessmentSearch : qiDepartmentSearchText"
              (onSelectionChange)="onQiDepartmentSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div>
            <!-- Reference -->
            <label id="qi-reference-validation" for="qi-reference">
              {{dynamicLabel['REFERENCE'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['REFERENCE'].fieldNotes"
              [matTooltip]="dynamicLabel['REFERENCE'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedQiReference" (closed)="referenceSearchText=''"
            (click)="focusmethod('focus-reference-search')" (keydown.enter)="focusmethod('focus-reference-search')">
            <input type="search" id="focus-reference-search" class="dropdownsearchstyle"
              [(ngModel)]="referenceSearchText" matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onQiReferenceSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of qiReferenceDropDown | assessmentSearch : referenceSearchText"
              (onSelectionChange)="onQiReferenceSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6" *ngIf="visibleReferenceIfOthers">
          <div>
            <!-- Reference if Others -->
            <label id="qi-reference-others-validation" for="qi-reference-others">
              {{dynamicLabel['REFERENCE'].fieldName}}
              If Others</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <textarea id="referenceOthers" type="text" class="input-filed-textarea" style="margin-top: 8px;" rows="4"
            cols="50" [(ngModel)]="qmsQiFieldData.referenceOthers"
            (ngModelChange)="onNgModuleChange(qmsQiFieldData.referenceOthers, 'qi-reference-others-validation')"></textarea>
        </div>
        <div class="col-md-3 field-row">
          <div>
            <!-- Requested At -->
            <label id="qi-requested-at-validation" for="qi-requested-at">
              {{dynamicLabel['REQUESTED_AT'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
              [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedQiRequestedAtValue"
            (closed)="requestedSearchText=''" (click)="focusmethod('focus-requested-search')"
            (keydown.enter)="focusmethod('focus-requested-search')">
            <input type="search" id="focus-requested-search" class="dropdownsearchstyle"
              [(ngModel)]="requestedSearchText" matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onQiRequestedAtSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of qiRequestedAtDropdown | assessmentSearch : requestedSearchText"
              (onSelectionChange)="onQiRequestedAtSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3 field-row" *ngIf="selectedQiRequestedAtValue">
          <div>
            <label id="qi-corebusiness-area-validation" for="email">{{((this.bussinessAreaName ?? '' )+ ' ' +
              dynamicLabel['CORE_BUSINESS_AREA_NAME'].fieldName)}}</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput multiple placeholder="Select" #qiBusinessArea *ngIf="!isBusinessAreaEmpty"
            [(ngModel)]="selectedQiCoreBusinessAreaNameValue" (closed)="coreBusinessSearchText=''"
            [matTooltip]="selectedQiCoreBusinessAreaNameValue" (click)="focusmethod('focus-b-area-search')"
            (keydown.enter)="focusmethod('focus-b-area-search')">
            <input type="search" id="focus-b-area-search" class="dropdownsearchstyle"
              [(ngModel)]="coreBusinessSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isAllQIBusinessAreaSelected"
                (change)="toggleAllSelection('qiBusinessArea')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of qiCoreBusinessAreaNameDropdown| multiAssessmentSearchPipe :coreBusinessSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onQiCoreBusinessAreaSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50" *ngIf="isBusinessAreaEmpty"
            [(ngModel)]="selectedQiCoreBusinessAreaNameValue" (input)="limitCharacters($event, 'REQUESTED_AT')"
            (ngModelChange)="onNgModuleChange($event,'qi-corebusiness-area-validation')"></textarea>
        </div>
        <div class="col-md-3 field-row">
          <div>
            <!-- Evaluator -->
            <label id="evaluator-validation" for="evaluator">
              {{dynamicLabel['EVALUATOR_USER'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['EVALUATOR_USER'].fieldNotes"
              [matTooltip]="dynamicLabel['EVALUATOR_USER'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedQiEvaluator" (closed)="evaluatorSearchText=''"
            (click)="focusmethod('focus-evaluator-search')" (keydown.enter)="focusmethod('focus-evaluator-search')">
            <input type="search" id="focus-evaluator-search" class="dropdownsearchstyle"
              [(ngModel)]="evaluatorSearchText" matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onEvaluatorSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of qiEvaluatorDropDown | assessmentSearch : evaluatorSearchText"
              [value]="item.valueExp" (onSelectionChange)="onEvaluatorSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3 field-row">
          <div>
            <!-- Identified On -->
            <label id="qi-identified-on-validation" for="qi-identified-on">
              {{dynamicLabel['IDENTIFIED_ON'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['IDENTIFIED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['IDENTIFIED_ON'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
            [bsConfig]="identifiedOnConfig" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsQiFieldData.identifiedOn"
            (ngModelChange)="onNgModuleChange(qmsQiFieldData.identifiedOn, 'qi-identified-on-validation')">
        </div>
        <div class="col-md-3 field-row" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable == 'Y'">
          <div>
            <!-- Expected to be Started On -->
            <label id="qi-expected-to-be-started-on-validation" for="qi-expected-to-be-started-on">
              {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsQiFieldData.expectedToBeStartedOn"
            (ngModelChange)="onNgModuleChange(qmsQiFieldData.expectedToBeStartedOn, 'qi-expected-to-be-started-on-validation'); onExpectedToBeStartedOnChange()">
        </div>
        <div class="col-md-3 field-row">
          <div>
            <!-- Expected Closure Date -->
            <label id="qi-expected-closure-on-validation" for="qi-expected-closure-on">
              {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="qmsQiFieldData.expcetedClosureOn"
            (ngModelChange)="onNgModuleChange(qmsQiFieldData.expcetedClosureOn, 'qi-expected-closure-on-validation')">
        </div>
        <div class="col-md-6 field-row">
          <div>
            <!-- Short Description -->
            <label id="qi-short-description-validation" for="qi-short-description">
              {{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
            </label> <span class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="qmsQiFieldData.shortDescription"
            (ngModelChange)="onNgModuleChange(qmsQiFieldData.shortDescription, 'qi-short-description-validation')"
            maxlength="400">
        </div>
        <div class="col-md-3 field-row"
          *ngIf="this.qualityService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
          <!-- Is Effectiveness Check Mandatory? -->
          <div><label for="email">{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="qmsQiFieldData.effectivenessCheckReqd">
            <ng-container *ngIf="qmsQiFieldData.effectivenessCheckReqd; else no">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #no>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3 field-row">
          <div>
            <!-- Impact Type -->
            <label for="impact-type">{{dynamicLabel['IMPACT_TYPE'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['IMPACT_TYPE'].fieldNotes"
              [matTooltip]="dynamicLabel['IMPACT_TYPE'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedQiImpactType"
            (closed)="impactTypeSearchText=''" (click)="focusmethod('focus-impact-search')"
            (keydown.enter)="focusmethod('focus-impact-search')">
            <input type="search" id="focus-impact-search" class="dropdownsearchstyle" [(ngModel)]="impactTypeSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
            <mat-option *ngFor="let item of qiImpactTypeDropDown | assessmentSearch : impactTypeSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6 field-row">
          <div>
            <!-- Description -->
            <label for="descirption">{{dynamicLabel['DESCRIPTION'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['DESCRIPTION'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="qmsQiFieldData.description" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit">
              <i class="far fa-edit" (click)="openEditor('Description')"
                (keydown.enter)="openEditor('Description')"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6 field-row">
          <div>
            <!-- Impact Description -->
            <label for="impact-description">{{dynamicLabel['IMPACT_DESCRIPTION'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['IMPACT_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['IMPACT_DESCRIPTION'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="qmsQiFieldData.impactDescription" [config]="config" (paste)="onPaste($event)"
                [spellcheck]="true"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit">
              <i class="far fa-edit" (click)="openEditor('Impact Description')"
                (keydown.enter)="openEditor('Impact Description')"></i>
            </div>
          </div>
        </div>
        <div class="col-md-2"
          *ngIf="selectedGroupValue.length > 0 && qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y'">
          <!-- Is Risk Calculation Reqd? -->
          <div>
            <label for="risk-reqd">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
              [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="qmsQiFieldData.isRiskCalculationReqd">
            <ng-container *ngIf="qmsQiFieldData.isRiskCalculationReqd; else no">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #no>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="form-template ActivityPage">
          <app-flexible-fields #flexible [from]="'Master'"></app-flexible-fields>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="qiSave(qmsQiFieldData)" (keydown.enter)="qiSave(qmsQiFieldData)">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="qiCancelPopupFuntion()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #inAddPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelInPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div>
      <app-raise-in [raiseIncidentData]="false"></app-raise-in>
    </div>
  </div>
</ng-template>

<ng-template #ccAddPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelCcPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <app-raise-cc [raiseComplaintData]="false"></app-raise-cc>

  </div>
</ng-template>

<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 12 fields for a cleaner and more readable PDF
      </span>
    </label>
  </div>

  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>

    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #columns [(ngModel)]="selectedColumns"
          (closed)="excelPdfSearchText=''" (click)="focusmethod('focus-excel-pdf-search')"
          (keydown.enter)="focusmethod('focus-excel-pdf-search')">
          <input type="search" id="focus-excel-pdf-search" class="dropdownsearchstyle" [(ngModel)]="excelPdfSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="isAllColumns" (change)="toggleAllSelection('columns')">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of dropDownForPdfColumn | multiAssessmentSearchPipe : excelPdfSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
  </div>

  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>

</ng-template>

<ng-template #angularEditorTextarea>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAngularEditorData()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.textareaEditorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]="config1" [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="okAngularEditorData(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditorData()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<app-activity-au-trail></app-activity-au-trail>
<app-top-navigation [hidden]="true"></app-top-navigation>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
